/**
 * L'Invoice project translations - Empty States section
 */

const emptyStates = {
  // General
  noData: "No data",
  noDataAvailable: "No data available",
  // Customers
  noCustomers: "No customers",
  noCustomersFound: "No customers found",
  // Documents
  noDocuments: "No documents",
  noDocumentsDescription: "To see documents in the list, first add them.",
  addDocumentsFromTemplates: "Add Documents from templates",
  // LookUp
  noResults: "No results found",
  // Settings
  noBankAccounts: "No bank accounts",
  noBankAccountsDescription: "Add your first bank account to start using it in invoices",
  noCountriesAdded: "No countries added yet",
  // Actions
  refresh: "Refresh",
};

export default emptyStates;
